import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "验收明细", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tip-end" }, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pic-tip" }, "（至少2张，照片需带时间水印）", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "white-line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "验收结果", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" % ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_13 = {
  key: 0,
  class: "bottom-btn"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("提交")

import { ref, onMounted,computed, watch } from 'vue';
import { getAgentCheckOrderApi, getQinNiuTokenApi, postAgentCheckOrderApi } from "../../../api/production";

import { directUploadFile, dateFormat, toFixed } from "@/utils/util";
import { Notify, Dialog, ImagePreview } from 'vant';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const acceptanceTime = dateFormat()
const state = ref({
	token: route.query.token,
	dateShow: false,
	minDate: new Date(1970, 0, 1),
	maxDate: new Date(2040, 12, 31),
	currentDate: new Date(),
	lossShow: false,
	checkResultShow: false,
	orderId: "",//采购单
	receivingNoteId: "",//到货单
	acceptanceTime: acceptanceTime.YYYY + '-' + acceptanceTime.MM + '-' + acceptanceTime.DD + ' ' + acceptanceTime.hh + ':' + acceptanceTime.mm,
	acceptanceUser: { id: "", name: "" },//验收人名字
	acceptanceUserErrMsg: "",
	productClass: { id: "", name: "" },
	cooperation: { id: "", name: "" },//供应商
	warehouseName: "",//仓库
	sn: "",//批次号
	product: { id: "", name: "" },//商品
	productErrMsg: "",//商品
	productUnit: { id: "", name: "" },//商品单位 
	deliveryQuantity: "" as number | string,//到仓数量
	deliveryQuantityErrMsg: "",//到仓数量
	totalSamplingQuantity: "" as number | string,//抽检数量
	totalSamplingQuantityErrMsg: "",//抽检数量
	list: [{
		lossType: "-1",//损耗类型
		lossTypeErrMsg: "",//损耗类型
		lossNumber: "" as number | string,//损耗数量
		lossNumberErrMsg: "",//损耗数量
		lossRatio: "" as number | string,//损耗占比
		lossRatioErrMsg: "",//损耗占比
		lossRemark: "",//损耗说明
		lossImg: [] as any,//损耗图片
		lossImgErrMsg: false,//损耗图片
	}] as any,
	lossItemIndex: -1,//损耗类型下标
	lossTypeList: [//损耗类型
		{ id: 0, text: "坏果" },
		{ id: 1, text: "次果" },
		{ id: 2, text: "等外果" },
		{ id: 3, text: "其他" },
	],//验收结论
	totalLossQuantity: "" as number | string,//总损耗数量
	totalLossRatio: "" as number | string,//总损耗率
	companyBearLoss: "" as number | string,//公司承担损耗
	companyBearLossErrMsg: "",//公司承担损耗
	cooperationBearLoss: "" as number | string,//供应商承担损耗
	acceptanceConclusion: -1,//验收结论
	acceptanceConclusionErrMsg: "",//验收结论
	acceptanceConclusionList: [
		{ id: 0, text: '正常入库' },
		{ id: 1, text: '拒收' }
	],
	acceptanceRemark: "",//验收说明
	addLaborCost: "",//增加人工费,
	docmHeight: document.documentElement.clientHeight,  // 默认屏幕高度
	showHeight: document.documentElement.clientHeight,   // 实时屏幕高度
	hideshow: true // 显示或者隐藏
})
window.onresize = ()=>{
	state.value.showHeight = document.documentElement.clientHeight
	if(state.value.docmHeight > state.value.showHeight) {
		state.value.hideshow = false
	} else {
		state.value.hideshow = true
	}
}
const addListItem = () => {
	state.value.list.push({
		lossType: "-1",//损耗类型
		lossTypeErrMsg: "",//损耗类型
		lossNumber: "" as number | string,//损耗数量
		lossNumberErrMsg: "",//损耗数量
		lossRatio: "" as number | string,//损耗占比
		lossRatioErrMsg: "",//损耗占比
		lossRemark: "",//损耗说明
		lossImg: [] as any,//损耗图片
		lossImgErrMsg: false,//损耗图片
	})
}
const delItem = (index: number) => {
	Dialog.confirm({ title: "提示", message: "确认删除此项损耗类型吗？" }).then(() => {
		state.value.list = state.value.list.filter((item: any, idx: number) => idx != index)
	});
}
const popShowFn = (name: any, boo: boolean, index: number = -1) => {
	(state.value as any)[name] = boo
	if (index != -1) state.value.lossItemIndex = index;
}
const postInfo = () => {
	if (!verify()) {
		Notify({ type: "danger", message: "请完善信息" });
		return
	}
	let tempData = state.value
	let list = tempData.list.map((item: any) => {
		let lossImgIds = item.lossImg.map((value: any) => value.id).join(",")
		return {
			lossType: item.lossType,//损耗类型
			lossNumber: item.lossNumber,//损耗数量
			lossRatio: item.lossRatio,//损耗占比
			lossRemark: item.lossRemark,//损耗说明
			lossImgIds,//损耗图片
		}
	})
	let obj: any = {
		orderId: tempData.orderId,
		receivingNoteId: tempData.receivingNoteId,
		acceptanceTime: tempData.acceptanceTime + ':00',
		acceptanceUserId: tempData.acceptanceUser.id,
		cooperationId: tempData.cooperation.id,
		warehouseName: tempData.warehouseName,
		sn: tempData.sn,
		productId: tempData.product.id,
		productUnitCode: tempData.productUnit.id,
		productUnitName: tempData.productUnit.name,
		productClassCode: tempData.productClass.id,
		productClassName: tempData.productClass.name,
		deliveryQuantity: tempData.deliveryQuantity,
		totalSamplingQuantity: tempData.totalSamplingQuantity,
		list,
		totalLossQuantity: toFixed(tempData.totalLossQuantity),
		totalLossRatio: toFixed(tempData.totalLossRatio),
		companyBearLoss: tempData.companyBearLoss,
		cooperationBearLoss: toFixed(tempData.cooperationBearLoss),
		acceptanceConclusion: tempData.acceptanceConclusion,
		acceptanceRemark: tempData.acceptanceRemark,
		addLaborCost: tempData.addLaborCost,
		token:tempData.token
	}
	postAgentCheckOrderApi(obj).then((res: any) => {
		console.log(res);
		router.push({
			path: "/agent/agentSuccess"
		})
	})
}

const verify = () => {
	let tempData = state.value
	let isConfirm = true
	if (!tempData.acceptanceUser.id) {
		isConfirm = false
		var acceptanceUserErrMsg = "请选择验收人"
	} else {
		var acceptanceUserErrMsg = ""
	}
	if (!tempData.deliveryQuantity) {
		isConfirm = false
		var deliveryQuantityErrMsg = "请输入到仓数量"
	} else {
		var deliveryQuantityErrMsg = ""
	}
	if (!tempData.totalSamplingQuantity) {
		isConfirm = false
		var totalSamplingQuantityErrMsg = "请输入抽检数量"
	} else {
		var totalSamplingQuantityErrMsg = ""
	}
	if (!tempData.companyBearLoss) {
		isConfirm = false
		var companyBearLossErrMsg = "请输入采购方承担损耗"
	} else {
		var companyBearLossErrMsg = ""
	}
	if (tempData.acceptanceConclusion == -1) {
		isConfirm = false
		var acceptanceConclusionErrMsg = "请输入验收结论"
	} else {
		var acceptanceConclusionErrMsg = ""
	}
	let list = tempData.list.map((item: any) => {
		if (item.lossType == -1) {
			isConfirm = false
			item.lossTypeErrMsg = "请选择损耗类型"
		} else {
			item.lossTypeErrMsg = ""
		}
		if (!item.lossNumber) {
			isConfirm = false
			item.lossNumberErrMsg = "请输入损耗数量"
		} else {
			item.lossNumberErrMsg = ""
		}
		if (!item.lossImg.length) {
			isConfirm = false
			item.lossImgErrMsg = true
		} else {
			item.lossImgErrMsg = false
		}
		return item
	})
	state.value = {
		...state.value,
		acceptanceUserErrMsg,
		deliveryQuantityErrMsg,
		totalSamplingQuantityErrMsg,
		companyBearLossErrMsg,
		acceptanceConclusionErrMsg,
		list
	}
	return isConfirm
}
const calcTotalLossQuantity = () => {
	let tempdata = state.value
	let totalLossQuantity = 0
	let totalLossRatio = 0
	let { totalSamplingQuantity } = tempdata
	let list = tempdata.list.map((item: any) => {
		totalLossQuantity += Number(item.lossNumber)
		if (totalSamplingQuantity) {
			item.lossRatio = (item.lossNumber / Number(totalSamplingQuantity)) * 100
			item.lossRatio = toFixed(item.lossRatio)
		}
		return item
	})
	totalLossRatio = (totalLossQuantity / Number(totalSamplingQuantity)) * 100
	let cooperationBearLoss = totalLossRatio - Number(tempdata.companyBearLoss)
	state.value = { ...tempdata, totalLossQuantity:toFixed(totalLossQuantity), totalLossRatio:toFixed(totalLossRatio), cooperationBearLoss:toFixed(cooperationBearLoss), list }
}
const lossConfirm = (data: any) => {
	let index = state.value.lossItemIndex
	state.value.list[index].lossType = data.id
	popShowFn('lossShow', false)
}
const checkResultConfirm = (data: any) => {
	state.value.acceptanceConclusion = data.id
	popShowFn('checkResultShow', false)
}
const confirmDateSelect = (e: any) => {
	const tempDate = dateFormat(e);
	state.value.acceptanceTime = tempDate.YYYY + "-" + tempDate.MM + "-" + tempDate.DD + ' ' + tempDate.hh + ':' + tempDate.mm;
	state.value.currentDate = new Date(state.value.acceptanceTime)
	popShowFn('dateShow', false)
};
const imageUploadAfter = async (e: any) => {
	if (Array.isArray(e)) {
		e.forEach(async (item) => {
			const result: any = await getQinNiuTokenApi({
				bucket: "xfarmer",
				fileType: 0,
				type: 2,
				token: "",
			});
			if (result.data.code == 0) {
				// 执行该函数后，获取数据请直接从双向绑定的数组中取值.
				directUploadFile(item, result.data,{ userType: '2', fileType: '0' }, "");
			}
		});
	} else {
		const result: any = await getQinNiuTokenApi({
			bucket: "xfarmer",
			fileType: 0,
			type: 2,
			token: "",
		});
		if (result.data.code == 0) {
			directUploadFile(e, result.data,{ userType: '2', fileType: '0' }, "");
		}
	}
};
const onDeleteImg = (e: any, index: number) => {
	state.value.list = state.value.list.map((item: any, idx: number) => {
		if (index == idx) {
			item.lossImg.splice(e.index, 1);
		}
		return item
	})
}
const onClickImgPoster = (e: any, index: number) => {
	state.value.list.forEach((item: any, idx: number) => {
		if (index == idx) {
			let temp = item.lossImg.map((items: any) => items.url);
			ImagePreview({
				images: temp,
				startPosition: 0,
			});
		}
	})
}
const getDeatail = () => {
	getAgentCheckOrderApi({ token: state.value.token }).then((res: any) => {
		let tempData = res.data.data
		state.value.orderId = tempData.orderId
		state.value.receivingNoteId = tempData.receivingNoteId
		state.value.warehouseName = tempData.warehouseName
		state.value.acceptanceUser = {
			name: tempData.acceptanceUserName,
			id: tempData.acceptanceUserId,
		}
		state.value.cooperation = {
			name: tempData.cooperationName,
			id: tempData.cooperationId,
		}
		state.value.product = {
			name: tempData.productName,
			id: tempData.productId,
		}
		state.value.productUnit = {
			name: tempData.productUnitName,
			id: tempData.productUnitCode,
		}
		state.value.productClass = {
			name: tempData.productClassName,
			id: tempData.productClassCode,
		}
	})
}
onMounted(() => {
	getDeatail()
})

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      label: "关联采购单",
      modelValue: state.value.orderId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (state.value.orderId = $event)),
      placeholder: "自动生成",
      readonly: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "关联到货单",
      modelValue: state.value.receivingNoteId,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (state.value.receivingNoteId = $event)),
      placeholder: "自动生成",
      readonly: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "验收时间",
      required: ""
    }, {
      input: _withCtx(() => [
        _createElementVNode("div", {
          class: "picker",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (popShowFn('dateShow', true)))
        }, _toDisplayString(state.value.acceptanceTime), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      label: "委托验收人",
      modelValue: state.value.acceptanceUser.name,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (state.value.acceptanceUser.name = $event)),
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "供应商",
      modelValue: state.value.cooperation.name,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (state.value.cooperation.name = $event)),
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "仓库名",
      modelValue: state.value.warehouseName,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (state.value.warehouseName = $event)),
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "批次号",
      modelValue: state.value.sn,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (state.value.sn = $event)),
      placeholder: "请输入",
      maxlength: 25
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "商品名",
      modelValue: state.value.product.name,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (state.value.product.name = $event)),
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "商品类别",
      modelValue: state.value.productClass.name,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (state.value.productClass.name = $event)),
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "到仓数量",
      onInput: calcTotalLossQuantity,
      modelValue: state.value.deliveryQuantity,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (state.value.deliveryQuantity = $event)),
      "error-message": state.value.deliveryQuantityErrMsg,
      placeholder: "请输入",
      maxlength: 12,
      type: "number",
      required: ""
    }, {
      "right-icon": _withCtx(() => [
        _createTextVNode(_toDisplayString(state.value.productUnit.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "error-message"]),
    _hoisted_2,
    _createVNode(_component_van_field, {
      label: "抽捡数量",
      modelValue: state.value.totalSamplingQuantity,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (state.value.totalSamplingQuantity = $event)),
      onInput: calcTotalLossQuantity,
      "error-message": state.value.totalSamplingQuantityErrMsg,
      placeholder: "请输入",
      maxlength: 25,
      type: "number",
      required: ""
    }, {
      "right-icon": _withCtx(() => [
        _createTextVNode(_toDisplayString(state.value.productUnit.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "error-message"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.list, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_3,
        _createVNode(_component_van_field, {
          label: "损耗类型",
          "error-message": item.lossTypeErrMsg,
          required: ""
        }, {
          input: _withCtx(() => [
            _createElementVNode("div", {
              class: "picker",
              onClick: ($event: any) => (popShowFn('lossShow', true, index))
            }, _toDisplayString(item.lossType == -1 ? '请选择' : state.value.lossTypeList[item.lossType].text), 9, _hoisted_4)
          ]),
          "right-icon": _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "delete-o",
              color: "#c80000",
              onClick: ($event: any) => (delItem(index))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["error-message"]),
        _createVNode(_component_van_field, {
          label: "损耗数量",
          modelValue: item.lossNumber,
          "onUpdate:modelValue": ($event: any) => (item.lossNumber = $event),
          onInput: calcTotalLossQuantity,
          "error-message": item.lossNumberErrMsg,
          type: "number",
          maxlength: 25,
          placeholder: "请输入",
          required: ""
        }, {
          "right-icon": _withCtx(() => [
            _createTextVNode(_toDisplayString(state.value.productUnit.name), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "error-message"]),
        _createVNode(_component_van_field, {
          label: "损耗占比",
          modelValue: item.lossRatio,
          "onUpdate:modelValue": ($event: any) => (item.lossRatio = $event),
          type: "number",
          placeholder: "自动生成",
          readonly: "",
          required: ""
        }, {
          "right-icon": _withCtx(() => [
            _hoisted_5
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_van_field, {
          label: "损耗说明",
          modelValue: item.lossRemark,
          "onUpdate:modelValue": ($event: any) => (item.lossRemark = $event),
          placeholder: "请输入",
          maxlength: 255
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_van_field, {
          label: "损耗照片",
          border: false,
          "error-message": item.lossImgErrMsg,
          required: "",
          readonly: ""
        }, null, 8, ["error-message"]),
        _hoisted_6,
        _createVNode(_component_stcp_h5_uploader, {
          modelValue: item.lossImg,
          "onUpdate:modelValue": ($event: any) => (item.lossImg = $event),
          multiple: "",
          "after-read": imageUploadAfter,
          onDelete: ($event: any) => (onDeleteImg($event, index)),
          "max-count": 9,
          onPoster: ($event: any) => (onClickImgPoster($event, index)),
          class: "upload"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onDelete", "onPoster"]),
        _hoisted_7
      ], 64))
    }), 256)),
    _createElementVNode("div", {
      class: "add-item",
      onClick: addListItem
    }, "+添加损耗类型"),
    _hoisted_8,
    _createVNode(_component_van_field, {
      label: "总损耗数量",
      modelValue: state.value.totalLossQuantity,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (state.value.totalLossQuantity = $event)),
      "label-width": "8em",
      placeholder: "自动生成",
      readonly: "",
      required: ""
    }, {
      "right-icon": _withCtx(() => [
        _createTextVNode(_toDisplayString(state.value.productUnit.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "总损耗率",
      modelValue: state.value.totalLossRatio,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (state.value.totalLossRatio = $event)),
      "label-width": "8em",
      placeholder: "自动生成",
      readonly: ""
    }, {
      "right-icon": _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "我司承担损耗",
      onInput: calcTotalLossQuantity,
      modelValue: state.value.companyBearLoss,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (state.value.companyBearLoss = $event)),
      "error-message": state.value.companyBearLossErrMsg,
      "label-width": "8em",
      placeholder: "请输入",
      maxlength: 25,
      type: "number",
      required: ""
    }, {
      "right-icon": _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue", "error-message"]),
    _createVNode(_component_van_field, {
      label: "供应商承担损耗",
      modelValue: state.value.cooperationBearLoss,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (state.value.cooperationBearLoss = $event)),
      "label-width": "8em",
      readonly: "",
      placeholder: "自动生成",
      required: ""
    }, {
      "right-icon": _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "验收结论",
      "error-message": state.value.acceptanceConclusionErrMsg,
      "label-width": "8em",
      required: ""
    }, {
      input: _withCtx(() => [
        _createElementVNode("div", {
          class: "picker",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (popShowFn('checkResultShow', true)))
        }, _toDisplayString(state.value.acceptanceConclusion == -1 ? '请选择' : state.value.acceptanceConclusionList[state.value.acceptanceConclusion].text), 1)
      ]),
      _: 1
    }, 8, ["error-message"]),
    _createVNode(_component_van_field, {
      label: "验收说明",
      modelValue: state.value.acceptanceRemark,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (state.value.acceptanceRemark = $event)),
      "label-width": "8em",
      placeholder: "请输入",
      maxlength: 255
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      label: "增加人工费",
      modelValue: state.value.addLaborCost,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (state.value.addLaborCost = $event)),
      "label-width": "8em",
      placeholder: "请输入",
      maxlength: 25
    }, {
      "right-icon": _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (state.value.hideshow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            onClick: postInfo,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      onClose: _cache[20] || (_cache[20] = ($event: any) => (popShowFn('dateShow', false))),
      show: state.value.dateShow,
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: state.value.currentDate,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (state.value.currentDate = $event)),
          type: "datetime",
          title: "验收时间",
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (popShowFn('dateShow', false))),
          onConfirm: confirmDateSelect,
          "min-date": state.value.minDate,
          "max-date": state.value.maxDate
        }, null, 8, ["modelValue", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      onClose: _cache[23] || (_cache[23] = ($event: any) => (popShowFn('lossShow', false))),
      show: state.value.lossShow,
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          modelValue: state.value.acceptanceConclusion,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (state.value.acceptanceConclusion = $event)),
          title: "损耗类型",
          columns: state.value.lossTypeList,
          onConfirm: lossConfirm,
          onCancel: _cache[22] || (_cache[22] = ($event: any) => (popShowFn('lossShow', false)))
        }, null, 8, ["modelValue", "columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      onClose: _cache[26] || (_cache[26] = ($event: any) => (popShowFn('checkResultShow', false))),
      show: state.value.checkResultShow,
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          modelValue: state.value.acceptanceConclusion,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (state.value.acceptanceConclusion = $event)),
          title: "损耗类型",
          columns: state.value.acceptanceConclusionList,
          onConfirm: checkResultConfirm,
          onCancel: _cache[25] || (_cache[25] = ($event: any) => (popShowFn('checkResultShow', false)))
        }, null, 8, ["modelValue", "columns"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})